import React from 'react';
import { ArrowDownIcon, CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../../data/content';
import { SectionCTA } from '../SectionCTA';
export function BeforeAfter() {
  return <section className="w-full bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-91" data-mp="26ne6vv2jaza0">
      <div className="mx-auto max-w-5xl" data-id="element-92" data-mp="22l149fj33hhg">
        <h2 className="text-center font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-93" data-mp="22mc7ne8man81">
          The same case, two very different processes
        </h2>

        <div className="mt-10 grid gap-5 lg:grid-cols-2 lg:gap-6" data-id="element-94" data-mp="2ubp50qguikul">
          {/* BEFORE */}
          <div className="flex flex-col rounded-3xl border border-flag/25 bg-[#fdf6f2] p-5 sm:p-6" data-id="element-95" data-mp="2q9u0ld3mbrcl">
            <div className="flex items-center gap-2.5 border-b border-flag/20 pb-4" data-id="element-96" data-mp="2lc20hvstkyxb">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-flag/10" data-id="element-97" data-mp="1eux3dfxa5vu5">
                <XIcon className="h-5 w-5 text-flag" aria-hidden="true" data-id="element-98" data-mp="19wdbyzzx3rue" />
              </span>
              <h3 className="text-[12.5px] font-extrabold uppercase tracking-[0.12em] text-flag" data-id="element-99" data-mp="175m3r27wxcd5">
                Before · Without a workflow
              </h3>
            </div>
            <ul className="mt-4 flex-1 space-y-3" data-id="element-100" data-mp="1c2336skkbd5j">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-101" data-mp="y6se5vt01m93">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-flag/70" aria-hidden="true" data-id="element-102" data-mp="132g2ya3kkde2" />
                  <span className="text-[14.5px] leading-snug text-ink-soft" data-id="element-103" data-mp="t5bbpvuv9rqe">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* AFTER */}
          <div className="flex flex-col rounded-3xl border border-go/30 bg-go-light p-5 shadow-soft sm:p-6" data-id="element-104" data-mp="fcdbnw7hbbgi">
            <div className="flex items-center gap-2.5 border-b border-go/25 pb-4" data-id="element-105" data-mp="5g0g0ssdinj4">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-go/15" data-id="element-106" data-mp="5icx73qb4tv4">
                <CheckIcon className="h-5 w-5 text-go-dark" aria-hidden="true" data-id="element-107" data-mp="ah6fd9gjh91m" />
              </span>
              <h3 className="text-[12.5px] font-extrabold uppercase tracking-[0.12em] text-go-dark" data-id="element-108" data-mp="2c63uy0bgkrmz">
                After · With the Workflow Builder
              </h3>
            </div>
            <ul className="mt-4 flex-1 space-y-3" data-id="element-109" data-mp="23c7duzx5i5ef">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-110" data-mp="1yepadp1wkidt">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-go-dark" aria-hidden="true" data-id="element-111" data-mp="2v23qtm7k4fbu" />
                  <span className="text-[14.5px] font-medium leading-snug text-ink" data-id="element-112" data-mp="2m2gn2trcuxfm">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-md rounded-3xl bg-navy-700 p-6 text-center" data-id="element-113" data-mp="2h5gh0iui9uoi">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-white/50" data-id="element-114" data-mp="1aol7jjwjgmnv">From:</p>
          <p className="mt-1.5 font-display text-xl italic text-white/80" data-id="element-115" data-mp="15mvtrwhxluw3">
            “Where do I even start?”
          </p>
          <ArrowDownIcon className="mx-auto my-4 h-5 w-5 text-go" aria-hidden="true" data-id="element-116" data-mp="vifilgfed1ym" />
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-go" data-id="element-117" data-mp="10h8wvb2icwzu">To:</p>
          <p className="mt-1.5 font-display text-xl italic leading-snug text-white" data-id="element-118" data-mp="15h4wky46a29l">
            “I know which stage of my workflow I’m working through.”
          </p>
        </div>

        <SectionCTA transformation="Move from hesitation to a clear, repeatable sequence." label="I want the After column" subline="$27 one-time · Instant digital access" data-id="element-119" data-mp="1ea89n5awod3p" />
      </div>
    </section>;
}